import { BaseModel } from 'storm-react-diagrams';
import {
  BaseLinkModel,
  BaseNodeModel,
  IntentDataModel,
  ModuleNodeModel
} from '../../../models';
import { IconClass } from '../../../types';

const defaultIcon = IconClass.disc;

/** Gets the icon that should be displayed for the given model. */
export function getModelIcon(model: BaseModel<any>): IconClass {
  if (model instanceof BaseLinkModel) {
    return IconClass.link;
  } else if (model instanceof IntentDataModel) {
    return model.getProperty('iconClass') ?? defaultIcon;
  } else if (model instanceof ModuleNodeModel) {
    return (
      'isCommonModule' in model.props
      && model.props.isCommonModule
    ) ? IconClass.globe : model.props.iconClass;
  } else if (model instanceof BaseNodeModel) {
    return model.props.iconClass;
  }

  console.error('No icon specified for model', model);
  return defaultIcon;
}
